import { toast } from "sonner";
import { Button } from "../../components/ui/button.jsx";

export function showCallNotification(opts) {
  const id = toast.custom(
    (t) => (
      <div className="w-[360px] overflow-hidden rounded-3xl border border-[#1f2c34] bg-[#0b141a] text-[#e9edef] shadow-2xl">
        <div className="flex items-center gap-3 bg-gradient-to-br from-[#075e54] to-[#128c7e] px-5 py-4">
          <div
            className="h-12 w-12 rounded-full border-2 border-white/40 bg-center bg-cover"
            style={{ backgroundImage: `url(${opts.avatarUrl || "https://i.pravatar.cc/100?img=8"})` }}
          />
          <div className="min-w-0 flex-1">
            <div className="text-[11px] uppercase tracking-[0.18em] text-white/70">Video call</div>
            <div className="truncate text-lg font-semibold text-white">{opts.name || "Incoming call"}</div>
            <div className="text-xs text-white/85">{opts.title || "Tap accept to join instantly."}</div>
          </div>
        </div>
        <div className="space-y-3 bg-[#111b21] px-5 py-4 text-sm">
          {opts.subtitle && <div className="text-xs text-[#8696a0]">{opts.subtitle}</div>}
          <div className="flex items-center justify-between gap-4">
            <button
              type="button"
              onClick={() => { toast.dismiss(t); opts.onDecline?.(); }}
              className="flex-1 rounded-full bg-[#f15a4f] py-2 text-sm font-semibold text-white shadow-md transition hover:bg-[#f87168]"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={() => { toast.dismiss(t); opts.onApprove?.(); }}
              className="flex-1 rounded-full bg-[#25d366] py-2 text-sm font-semibold text-[#0b141a] shadow-md transition hover:bg-[#2ecc71]"
            >
              Accept
            </button>
          </div>
          <div className="text-[11px] text-[#8696a0]">
            Join link:
            <a className="ml-1 text-[#25d366] underline" href={`/call?incoming=1&room=${encodeURIComponent(opts.room || "call:demo")}`}>
              {`/call?room=${encodeURIComponent(opts.room || "call:demo")}`}
            </a>
          </div>
        </div>
      </div>
    ),
    { duration: 8000, position: "top-right" },
  );
  return id;
}

function formatPhone(phone){
  if (!phone) return "";
  const digits = String(phone).replace(/\D+/g, "");
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+1 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  if (digits.length > 0) return `+${digits}`;
  return "";
}

export function showPhoneCallDemo(opts){
  const formatted = formatPhone(opts.phone);
  const id = toast.custom(
    (t) => (
      <div className="w-[300px] overflow-hidden rounded-[28px] border border-[#1f2c34] bg-[#0b141a] text-[#e9edef] shadow-2xl">
        <div className="bg-gradient-to-br from-[#075e54] to-[#128c7e] px-5 py-6 text-center">
          <div className="text-[11px] uppercase tracking-[0.18em] text-white/70">Incoming call</div>
          <div className="mt-2 text-xl font-semibold text-white">{opts.fromName || "Meeting invite"}</div>
          {formatted && <div className="mt-1 text-sm text-white/80">{formatted}</div>}
        </div>
        <div className="space-y-3 px-5 py-4 text-sm">
          <p className="text-center text-[#cfd4d8]">Answer from your device or accept here.</p>
          <div className="flex items-center justify-center gap-4">
            <button
              type="button"
              className="grid h-12 w-12 place-items-center rounded-full bg-[#f15a4f] text-white shadow-lg"
              onClick={() => { toast.dismiss(t); opts.onDecline?.(); }}
              aria-label="Decline call"
            >
              ✕
            </button>
            <button
              type="button"
              className="grid h-12 w-12 place-items-center rounded-full bg-[#25d366] text-[#0b141a] shadow-lg"
              onClick={() => { toast.dismiss(t); opts.onApprove?.(); }}
              aria-label="Accept call"
            >
              ✔
            </button>
          </div>
          <Button
            variant="secondary"
            className="w-full border-[#1f2c34] bg-[#202c33] text-[#e9edef] hover:bg-[#1f2c34]"
            onClick={() => { toast.dismiss(t); opts.onApprove?.(); }}
          >
            Join via desktop
          </Button>
        </div>
        <div className="bg-[#111b21] px-5 py-3 text-center text-[11px] text-[#8696a0]">
          Share link:
          <a className="ml-1 text-[#25d366] underline" href={`/call?incoming=1&room=${encodeURIComponent(opts.room || "call:demo")}`}>
            Join call
          </a>
        </div>
      </div>
    ),
    { duration: 8000, position: "top-center" },
  );
  return id;
}
